import { render, staticRenderFns } from "./AddPrizeForm.vue?vue&type=template&id=750501b8&scoped=true&"
import script from "./AddPrizeForm.vue?vue&type=script&lang=js&"
export * from "./AddPrizeForm.vue?vue&type=script&lang=js&"
import style0 from "./AddPrizeForm.vue?vue&type=style&index=0&id=750501b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750501b8",
  null
  
)

export default component.exports